// extracted by mini-css-extract-plugin
module.exports = {"links":"footerLinks-module--links--1l8zZ","item":"footerLinks-module--item--37xzv"};